<template>
    <div class="flex gap-x-6 items-center">
        <avatar v-if="participant.profile_image_url" :url="participant.profile_image_url" width="35px" height="35px" />
        <loader v-show="loading" class="absolute opacity-50" :height="35" />

        <div>
            <p class="mb-0">{{ participant.name ? participant.name : participant.realname }}</p>

            <p v-if="isOrganizer" class="mb-0 n-color-text-weaker">{{ trans('apps.team_meetings.organizer') }}</p>

            <ep-banner v-show="editable && bookedSlot" class="p-0 m-b-0" variant="warning">
                {{ trans('apps.team_meetings.participant_booked') }}
            </ep-banner>
        </div>

        <i
            v-show="currentUserHasEditAccess && !participant.canSeeMeeting"
            v-tooltip="trans('apps.team_meetings.cannot_view_meeting')"
            class="far fa-eye-slash group-hover:hidden w-6"
            :class="{ 'cursor-pointer': editable }"
        ></i>
    </div>
</template>

<script>
import Avatar from '@/system/components/global/Avatar';
import Loader from '@/system/components/global/Loader';

export default {
    components: {
        Loader,
        Avatar
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },

        isOrganizer: {
            type: Boolean,
            default: false,
        },

        participant: {
            type: Object,
            required: true,
        },

        currentUserHasEditAccess: {
            type: Boolean,
            default: false,
        },

        editable: {
            type: Boolean,
            default: false,
        },

        bookedSlot: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
